import React from 'react';
import Switch from '@material-ui/core/Switch';
import {withStyles} from '@material-ui/core/styles';
import Collapse from '@material-ui/core/Collapse';
import settingsStyles from '../settingsStyles';

// Acik/kapali ayarlar icin yesil switch — durum rengi marka renginden ayri tutulur.
const GreenSwitch = withStyles({
    root: {
        width: 42,
        height: 24,
        padding: 0,
        display: 'flex',
    },
    switchBase: {
        padding: 3,
        color: '#fff',
        '&$checked': {
            transform: 'translateX(18px)',
            color: '#fff',
            '& + $track': {
                backgroundColor: '#157f4f',
                opacity: 1,
                border: 'none',
            },
        },
        '&$disabled + $track': {
            opacity: 0.35,
        },
    },
    thumb: {
        width: 18,
        height: 18,
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.35)',
    },
    track: {
        borderRadius: 999,
        backgroundColor: '#8a95a5',
        opacity: 1,
    },
    checked: {},
    disabled: {},
})(Switch);

/**
 * Tek bir ayar satiri.
 *
 * icon        Font Awesome sinifi
 * title       Ayar adi
 * badge       Basligin yanindaki rozet (StatusPill)
 * description Aciklama metni
 * active      Satirin acik gorunumu (ikon yesile doner)
 * control     Sag taraftaki kontrol (buton vb.) — switch yerine kullanilir
 * checked     Switch degeri (tanimliysa switch cizilir)
 * onToggle    Switch degisimi
 * disabled    Switch pasif
 * children    Satir altindaki ayrinti paneli — switch acikken gorunur
 * alwaysOpen  Ayrinti panelini switch durumundan bagimsiz acik tutar
 */
// Satir altindaki alt secenekler (orn. uclu butonun her bir dugmesi) ayni
// gorsel dili kullansin diye switch disari aciliyor.
export function InlineSwitch({checked, onChange, disabled, label}) {
    return (
        <GreenSwitch
            disableRipple
            checked={!!checked}
            onChange={onChange}
            disabled={disabled}
            inputProps={{'aria-label': label}}
        />
    );
}

export default function SettingRow({
    icon,
    title,
    badge,
    description,
    active,
    control,
    checked,
    onToggle,
    disabled,
    children,
    alwaysOpen,
    ariaLabel,
}) {
    const classes = settingsStyles();
    const hasSwitch = typeof checked === 'boolean';
    const isActive = typeof active === 'boolean' ? active : checked;
    const panelOpen = alwaysOpen || (hasSwitch ? checked : true);

    return (
        <div className={classes.row}>
            <span className={`${classes.rowIcon} ${isActive ? classes.rowIconActive : ''}`}>
                <i className={icon} />
            </span>

            <div className={classes.rowBody}>
                <div className={classes.rowTitle}>
                    {title}
                    {badge}
                </div>
                {description && <p className={classes.rowDesc}>{description}</p>}
                {children && (
                    <Collapse in={panelOpen} timeout={180} unmountOnExit>
                        <div className={classes.subPanel}>{children}</div>
                    </Collapse>
                )}
            </div>

            <div className={classes.rowControl}>
                {control}
                {hasSwitch && (
                    <GreenSwitch
                        disableRipple
                        checked={checked}
                        onChange={onToggle}
                        disabled={disabled}
                        inputProps={{'aria-label': ariaLabel || title}}
                    />
                )}
            </div>
        </div>
    );
}
